import { newDiv, createImage } from '../RenderUtils';
import { addEvents } from './Events';
import { addAnalyticsAttribute } from '../../../helpers/analytics';
import { CONTROLS_EVENTS_GA } from './Constants';
import { LOCALES } from './Locales';

export class ScreenshotControl {
  constructor(container) {
    this.container = container;
  }

  render(action, SendAction) {
    const classContainer = 'ScreenshotControl';
    const classElement = 'ScreenshotControl-control';
    const content = createImage('/images/map/screenshot.png');

    const actionsDiv = newDiv(null, this.container);
    actionsDiv.classList.add(classContainer);
    actionsDiv.classList.add('UITooltip');
    actionsDiv.classList.add('-medium');

    const control = newDiv(content, actionsDiv);
    control.classList.add(classElement);

    addAnalyticsAttribute(control, CONTROLS_EVENTS_GA.SCREENSHOT);
    addEvents(control, action, SendAction);

    const tooltipContent = document.createElement('div');
    tooltipContent.classList.add('UITooltip-content');
    tooltipContent.innerText = LOCALES.SCREENSHOT_TOOLTIP[window.currentLanguage];
    newDiv(tooltipContent, control);
  }
}
